import { Decimal } from '../../datastructures';
import { createAsyncAtom } from '../../lib/state';
import poolDataAtom from './poolDataAtom';

const poolsAprAtom = createAsyncAtom(async get => {
  const poolData = await get(poolDataAtom);

  const poolAprs: Record<string, Decimal> = {};

  Object.entries(poolData).forEach(([poolId, data]) => {
    poolAprs[poolId] = data.baseApr;
  });

  return poolAprs;
});
export default poolsAprAtom;
